import axios from 'axios'
import { accessRequest } from '../utils/authConfig'
import { isTokenValid, retrieveTokenData, storeTokenData } from '../utils/storageUtils'
import { fetchAccessTokenForCognitoUser } from '../utils/authUtils'

// Using the cache to store instances by msalInstance reference
const apiInstanceCache = new Map()

export const getApiInstance = (msalInstance) => {
  // Check if we already have an instance for this msalInstance
  const cacheKey = msalInstance || 'default'
  if (apiInstanceCache.has(cacheKey)) {
    return apiInstanceCache.get(cacheKey)
  }

  const axiosInstance = axios.create()

  axiosInstance.interceptors.request.use(
    async (config) => {
      try {
        const loginType = localStorage.getItem('loginType')
        let validToken = ''

        if (loginType === 'cognito') {
          // Handle Cognito authentication
          validToken = await fetchAccessTokenForCognitoUser()
        } else if (msalInstance) {
          // Handle MSAL authentication
          const tokenData = await retrieveTokenData(msalInstance)

          if (isTokenValid(tokenData)) {
            validToken = tokenData.accessToken
          } else {
            // Token is not valid, acquire a new one
            const getNewToken = await msalInstance.acquireTokenSilent({
              ...accessRequest
            })

            const tokenObject = {
              accessToken: getNewToken?.accessToken || '',
              expiresOn: getNewToken?.expiresOn || '',
              extExpiresOn: getNewToken?.extExpiresOn || ''
            }

            storeTokenData(tokenObject)
            validToken = tokenObject.accessToken
          }
        } else {
          console.warn('No authentication method provided')
          throw new Error('No user logged in')
        }

        // Add Authorization header
        config.headers['Authorization'] = `Bearer ${validToken}`

        // Only set StoreId from localStorage if not already provided in the request headers
        if (!config.headers['StoreId']) {
          const selectedStore = JSON.parse(localStorage.getItem('selectedStore'))
          const storeId = selectedStore.id
          config.headers['StoreId'] = storeId
        }

        return config
      } catch (err) {
        console.error('Error in request interceptor:', err)
        return Promise.reject(err)
      }
    },
    (error) => {
      return Promise.reject(error)
    }
  )

  axiosInstance.interceptors.response.use(
    (response) => {
      return response
    },
    (error) => {
      console.error('API error:', error)

     if (error.response && error.response.status === 401) {
        console.warn('Authentication error - token may be expired')
      }

      return Promise.reject(error)
    }
  )

  // Store the instance in the cache
  apiInstanceCache.set(cacheKey, axiosInstance)
  return axiosInstance
}
